import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ExpandMojo = props => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d={
        `M19.0019 4C19.5542 4 20.0019 4.44771 20.0019 5L20.0019 10C20.0019 10.5523 19.5542 11 19.0019 11C18.4496 11 18.0019 10.5523 18.0019 10V7.42L14.7119 10.71L14.7061 10.7158C14.314 11.1047 13.6808 11.1021 13.2919 10.71L13.2861 10.7042C12.8972 10.3121 12.8998 9.67892 13.2919 9.29L16.5719 6H14.0019C13.4496 6 13.0019 5.55228 13.0019 5C13.0019 4.44771 13.4496 4 14.0019 4H19.0019ZM9.2958 13.2842C9.68792 12.8953 10.3211 12.8979 10.71 13.29L10.7158 13.2958C11.1047 13.6879 11.1021 14.3211 10.71 14.71L7.42 18H10C10.5523 18 11 18.4477 11 19C11 19.5523 10.5523 20 10 20H5C4.44771 20 4 19.5523 4 19V14C4 13.4477 4.44771 13 5 13C5.55228 13 6 13.4477 6 14V16.57L9.29 13.29L9.2958 13.2842Z`
      }
    />
  </SvgIcon>
);

export default ExpandMojo;
